/**
 * Bilingual translations. Each key has {es, en}.
 */
export const translations = {
  // Auth
  "auth.login": { es: "Iniciar sesión", en: "Sign in" },
  "auth.register": { es: "Crear cuenta", en: "Sign up" },
  "auth.email": { es: "Correo electrónico", en: "Email" },
  "auth.password": { es: "Contraseña", en: "Password" },
  "auth.name": { es: "Nombre", en: "Name" },
  "auth.logout": { es: "Cerrar sesión", en: "Log out" },
  "auth.no_account": { es: "¿No tienes cuenta?", en: "Don't have an account?" },
  "auth.have_account": { es: "¿Ya tienes cuenta?", en: "Already have an account?" },
  "auth.welcome_back": { es: "Bienvenido de nuevo", en: "Welcome back" },
  "auth.create_account": { es: "Crea tu cuenta", en: "Create your account" },
  "auth.tagline": {
    es: "Diseña planes de negocio con la ayuda de la inteligencia artificial.",
    en: "Craft business plans with the help of artificial intelligence.",
  },

  // Dashboard
  "dashboard.title": { es: "Mis Proyectos", en: "My Projects" },
  "dashboard.subtitle": {
    es: "Crea, organiza y desarrolla tus planes de negocio.",
    en: "Create, organize and develop your business plans.",
  },
  "dashboard.new_project": { es: "Nuevo proyecto", en: "New project" },
  "dashboard.empty_title": { es: "Aún no tienes proyectos", en: "No projects yet" },
  "dashboard.empty_desc": {
    es: "Comienza creando tu primer plan de negocio.",
    en: "Start by creating your first business plan.",
  },
  "dashboard.open": { es: "Abrir", en: "Open" },
  "dashboard.delete": { es: "Eliminar", en: "Delete" },

  // Project modal
  "modal.create_project": { es: "Crear nuevo proyecto", en: "Create new project" },
  "modal.project_name": { es: "Nombre del proyecto", en: "Project name" },
  "modal.project_desc": { es: "Descripción", en: "Description" },
  "modal.project_image": { es: "URL de imagen (opcional)", en: "Image URL (optional)" },
  "modal.cancel": { es: "Cancelar", en: "Cancel" },
  "modal.create": { es: "Crear", en: "Create" },

  // New project flow — method picker
  "flow.title": { es: "¿Cómo quieres empezar?", en: "How do you want to start?" },
  "flow.subtitle": {
    es: "Elige el método que prefieras para crear tu plan de negocio.",
    en: "Choose how you'd like to create your business plan.",
  },
  "flow.interview.title": { es: "Entrevista guiada", en: "Guided interview" },
  "flow.interview.desc": {
    es: "Un asistente IA te hace preguntas y rellena el plan con tus respuestas.",
    en: "An AI assistant asks you questions and fills the plan with your answers.",
  },
  "flow.interview.cta": { es: "Empezar entrevista", en: "Start interview" },
  "flow.creative.title": { es: "Autogeneración creativa", en: "Creative auto-generation" },
  "flow.creative.desc": {
    es: "Cuéntanos 4-5 parámetros básicos y la IA inventa todo el plan por ti.",
    en: "Give us 4-5 basic parameters and the AI invents the entire plan for you.",
  },
  "flow.creative.cta": { es: "Generar plan", en: "Generate plan" },
  "flow.manual.title": { es: "Empezar desde cero", en: "Start from scratch" },
  "flow.manual.desc": {
    es: "Proyecto vacío que rellenas manualmente módulo a módulo.",
    en: "Empty project — fill it manually module by module.",
  },
  "flow.manual.cta": { es: "Crear vacío", en: "Create empty" },

  // Interview wizard
  "interview.title": { es: "Asistente del Paso Cero", en: "Step-Zero Assistant" },
  "interview.progress": { es: "Pregunta", en: "Question" },
  "interview.of": { es: "de", en: "of" },
  "interview.skip": { es: "Saltar", en: "Skip" },
  "interview.next": { es: "Siguiente", en: "Next" },
  "interview.back": { es: "Atrás", en: "Back" },
  "interview.finish": { es: "Generar plan", en: "Generate plan" },
  "interview.generating_title": { es: "Diseñando tu plan...", en: "Designing your plan..." },
  "interview.generating_subtitle": {
    es: "La IA está sintetizando tus respuestas en un plan de negocio completo. Tarda 30-60 segundos.",
    en: "AI is synthesizing your answers into a complete business plan. Takes 30-60 seconds.",
  },
  "interview.step1": { es: "Definiendo concepto y propuesta de valor", en: "Defining concept and value proposition" },
  "interview.step2": { es: "Construyendo el Business Model Canvas", en: "Building the Business Model Canvas" },
  "interview.step3": { es: "Analizando mercado y buyer personas", en: "Analyzing market and buyer personas" },
  "interview.step4": { es: "Diseñando operaciones y equipo", en: "Designing operations and team" },
  "interview.step5": { es: "Calculando finanzas y proyecciones", en: "Crunching financials and projections" },
  "interview.step6": { es: "Identificando riesgos y mitigaciones", en: "Identifying risks and mitigations" },

  // Creative wizard
  "creative.title": { es: "Autogeneración Creativa", en: "Creative Auto-Generation" },
  "creative.subtitle": {
    es: "Rellena los parámetros básicos y la IA hará el resto.",
    en: "Fill in the basic parameters and the AI will do the rest.",
  },
  "creative.name": { es: "Nombre del proyecto", en: "Project name" },
  "creative.industry": { es: "Sector o industria", en: "Industry or sector" },
  "creative.target": { es: "Mercado objetivo", en: "Target market" },
  "creative.location": { es: "Ubicación principal", en: "Primary location" },
  "creative.budget": { es: "Presupuesto inicial estimado (€)", en: "Estimated initial budget (€)" },
  "creative.notes": { es: "Notas adicionales (opcional)", en: "Extra notes (optional)" },
  "creative.generate": { es: "Generar con IA", en: "Generate with AI" },

  // Modules
  "module.executive_summary": { es: "Resumen Ejecutivo", en: "Executive Summary" },
  "module.canvas": { es: "Business Model Canvas", en: "Business Model Canvas" },
  "module.concept": { es: "Creación Conceptual", en: "Concept Creation" },
  "module.market": { es: "Estudio de Mercado", en: "Market Research" },
  "module.operations": { es: "Operaciones", en: "Operations" },
  "module.hr": { es: "Recursos Humanos", en: "Human Resources" },
  "module.calendar": { es: "Calendario", en: "Calendar" },
  "module.marketing": { es: "Marketing", en: "Marketing" },
  "module.budget": { es: "Presupuesto", en: "Budget" },
  "module.risks": { es: "Análisis de Riesgos", en: "Risk Analysis" },
  "module.gya": { es: "Operaciones Especializadas", en: "Specialized Operations" },

  // GYA module
  "gya.subtitle": {
    es: "Vista especializada para negocios geo-distribuidos con múltiples segmentos.",
    en: "Specialized view for geo-distributed businesses with multiple segments.",
  },
  "gya.segments_title": { es: "Comparador de segmentos", en: "Segments comparator" },
  "gya.segments_subtitle": {
    es: "Persona · Customer journey · KPIs lado a lado.",
    en: "Persona · Customer journey · KPIs side by side.",
  },
  "gya.partners_title": { es: "Mapa de Partners por país", en: "Partners map by country" },
  "gya.partners_subtitle": {
    es: "Red local certificada por categoría y país.",
    en: "Certified local network by category and country.",
  },
  "gya.destinations_title": { es: "Plantillas de destinos", en: "Destination templates" },
  "gya.destinations_subtitle": {
    es: "Conocimiento listo para usar por país (visas · fiscal · sanidad · escuelas).",
    en: "Ready-to-use knowledge by country (visas · fiscal · healthcare · schools).",
  },
  "gya.funnel_title": { es: "Funnel agregado & LTV/CAC", en: "Aggregated funnel & LTV/CAC" },
  "gya.funnel_subtitle": {
    es: "KPIs blended de ambos segmentos.",
    en: "Blended KPIs across both segments.",
  },
  "gya.segment.persona": { es: "Persona", en: "Persona" },
  "gya.segment.journey": { es: "Customer Journey", en: "Customer Journey" },
  "gya.segment.kpis": { es: "KPIs", en: "KPIs" },
  "gya.segment.income": { es: "Income", en: "Income" },
  "gya.segment.motivation": { es: "Motivación", en: "Motivation" },
  "gya.segment.pains": { es: "Pains", en: "Pains" },
  "gya.segment.drivers": { es: "Decision drivers", en: "Decision drivers" },
  "gya.kpi.avg_ticket_initial": { es: "Ticket inicial medio", en: "Avg initial ticket" },
  "gya.kpi.avg_ticket_recurring": { es: "Ticket recurrente", en: "Avg recurring ticket" },
  "gya.kpi.ltv_3yr": { es: "LTV 3 años", en: "3-yr LTV" },
  "gya.kpi.ltv_5yr": { es: "LTV 5 años", en: "5-yr LTV" },
  "gya.kpi.cac_target": { es: "CAC objetivo", en: "Target CAC" },
  "gya.kpi.ltv_cac": { es: "Ratio LTV/CAC", en: "LTV/CAC ratio" },
  "gya.kpi.payback": { es: "Payback (meses)", en: "Payback (months)" },
  "gya.kpi.monthly_lead": { es: "Leads/mes objetivo", en: "Monthly lead target" },
  "gya.kpi.monthly_customers": { es: "Contratos/mes", en: "Monthly customers" },
  "gya.partners.category": { es: "Categoría", en: "Category" },
  "gya.partners.name": { es: "Partner", en: "Partner" },
  "gya.partners.city": { es: "Ciudad", en: "City" },
  "gya.partners.speciality": { es: "Especialidad", en: "Speciality" },
  "gya.partners.contract": { es: "Tipo contrato", en: "Contract type" },
  "gya.partners.rating": { es: "Rating", en: "Rating" },
  "gya.dest.visa_retirees": { es: "Visas para jubilados", en: "Visas for retirees" },
  "gya.dest.visa_workers": { es: "Visas para trabajadores / familias", en: "Visas for workers / families" },
  "gya.dest.fiscal": { es: "Fiscalidad clave", en: "Key fiscal highlights" },
  "gya.dest.col": { es: "Coste de vida (US=100)", en: "Cost of living (US=100)" },
  "gya.dest.healthcare": { es: "Sanidad", en: "Healthcare" },
  "gya.dest.schools_intl": { es: "Colegios internacionales", en: "International schools" },
  "gya.dest.schools_bilingual": { es: "Colegios bilingües", en: "Bilingual schools" },
  "gya.dest.community": { es: "Comunidad expat", en: "Expat community" },
  "gya.dest.best_retirees": { es: "Mejor para jubilados", en: "Best for retirees" },
  "gya.dest.best_families": { es: "Mejor para familias", en: "Best for families" },
  "gya.funnel.spend": { es: "Inversión marketing mensual", en: "Monthly marketing spend" },
  "gya.funnel.leads": { es: "Leads/mes total", en: "Total leads/mo" },
  "gya.funnel.consultations": { es: "Consultas/mes", en: "Consultations/mo" },
  "gya.funnel.proposals": { es: "Propuestas/mes", en: "Proposals/mo" },
  "gya.funnel.contracts": { es: "Contratos/mes", en: "Contracts/mo" },
  "gya.funnel.revenue_new": { es: "Revenue nuevo/mes", en: "New revenue/mo" },
  "gya.funnel.revenue_rec": { es: "Revenue recurrente/mes", en: "Recurring revenue/mo" },
  "gya.funnel.blended_ltv": { es: "LTV blended", en: "Blended LTV" },
  "gya.funnel.blended_cac": { es: "CAC blended", en: "Blended CAC" },
  "gya.funnel.blended_ratio": { es: "Ratio LTV/CAC blended", en: "Blended LTV/CAC" },

  // Canvas
  "canvas.subtitle": {
    es: "9 bloques fundamentales del modelo de Osterwalder.",
    en: "9 fundamental blocks of Osterwalder's model.",
  },
  "canvas.key_partners": { es: "Socios Clave", en: "Key Partners" },
  "canvas.key_activities": { es: "Actividades Clave", en: "Key Activities" },
  "canvas.key_resources": { es: "Recursos Clave", en: "Key Resources" },
  "canvas.value_propositions": { es: "Propuestas de Valor", en: "Value Propositions" },
  "canvas.customer_relationships": { es: "Relación con Clientes", en: "Customer Relationships" },
  "canvas.channels": { es: "Canales", en: "Channels" },
  "canvas.customer_segments": { es: "Segmentos de Clientes", en: "Customer Segments" },
  "canvas.cost_structure": { es: "Estructura de Costes", en: "Cost Structure" },
  "canvas.revenue_streams": { es: "Fuentes de Ingresos", en: "Revenue Streams" },
  "canvas.hint.key_partners": { es: "¿Quiénes son tus aliados estratégicos?", en: "Who are your strategic allies?" },
  "canvas.hint.key_activities": { es: "¿Qué haces para entregar valor?", en: "What do you do to deliver value?" },
  "canvas.hint.key_resources": { es: "Activos necesarios para operar.", en: "Assets needed to operate." },
  "canvas.hint.value_propositions": { es: "¿Qué problema resuelves y para quién?", en: "What problem do you solve and for whom?" },
  "canvas.hint.customer_relationships": { es: "Cómo te relacionas con cada segmento.", en: "How you relate to each segment." },
  "canvas.hint.channels": { es: "Cómo llegas a tus clientes.", en: "How you reach your customers." },
  "canvas.hint.customer_segments": { es: "¿Para quién creas valor?", en: "For whom do you create value?" },
  "canvas.hint.cost_structure": { es: "Costes más relevantes del modelo.", en: "Most relevant costs of the model." },
  "canvas.hint.revenue_streams": { es: "Cómo monetizas el valor entregado.", en: "How you monetize the delivered value." },
  "canvas.fill_with_ai": { es: "Rellenar todo con IA", en: "Fill all with AI" },

  // Lean toggle + One-Sheet
  "lean.lean": { es: "Lean", en: "Lean" },
  "lean.full": { es: "Completo", en: "Full" },
  "lean.label": { es: "Modo", en: "Mode" },
  "onesheet.title": { es: "Vista 1 página", en: "1-page snapshot" },
  "onesheet.subtitle": {
    es: "Snapshot del plan completo con los KPIs clave.",
    en: "Full plan snapshot with the key KPIs.",
  },
  "onesheet.button": { es: "Vista 1 página", en: "1-page view" },

  // Executive summary
  "exec.title": { es: "Resumen ejecutivo", en: "Executive summary" },
  "exec.subtitle": {
    es: "Síntesis del plan de negocio para inversores y stakeholders.",
    en: "Business plan synthesis for investors and stakeholders.",
  },
  "exec.generate": { es: "Generar con IA", en: "Generate with AI" },
  "exec.regenerate": { es: "Regenerar con IA", en: "Regenerate with AI" },
  "exec.last_generated": { es: "Última generación", en: "Last generated" },
  "exec.empty": {
    es: "Genera un resumen ejecutivo a partir de toda la información del plan.",
    en: "Generate an executive summary from all the plan data.",
  },
  "exec.placeholder": {
    es: "El resumen ejecutivo aparecerá aquí. Puedes editarlo manualmente o regenerarlo con IA.",
    en: "The executive summary will appear here. You can edit it manually or regenerate it with AI.",
  },

  // Concept (extended)
  "concept.mission": { es: "Misión", en: "Mission" },
  "concept.vision": { es: "Visión", en: "Vision" },
  "concept.values": { es: "Valores", en: "Values" },

  // Concept
  "concept.company_name": { es: "Nombre de la empresa", en: "Company name" },
  "concept.idea": { es: "Idea de negocio", en: "Business idea" },
  "concept.differentiators": { es: "Elementos diferenciadores", en: "Differentiators" },
  "concept.competitive_advantage": { es: "Ventaja competitiva", en: "Competitive advantage" },
  "concept.legal_form": { es: "Forma jurídica", en: "Legal form" },
  "concept.location": { es: "Ubicación", en: "Location" },
  "concept.partners": { es: "Socios y participación", en: "Partners & equity" },
  "concept.add_partner": { es: "Añadir socio", en: "Add partner" },
  "concept.partner_name": { es: "Nombre", en: "Name" },
  "concept.partner_role": { es: "Rol", en: "Role" },
  "concept.partner_equity": { es: "% Participación", en: "% Equity" },

  // Market
  "market.size": { es: "Tamaño de mercado", en: "Market size" },
  "market.opportunity": { es: "Oportunidad", en: "Opportunity" },
  "market.competitors": { es: "Competencia", en: "Competitors" },
  "market.add_competitor": { es: "Añadir competidor", en: "Add competitor" },
  "market.client_def": { es: "Definición del cliente", en: "Client definition" },
  "market.personas": { es: "Buyer Personas", en: "Buyer Personas" },
  "market.add_persona": { es: "Añadir persona", en: "Add persona" },
  "market.use_template": { es: "Usar plantilla", en: "Use template" },
  "market.swot": { es: "Análisis SWOT", en: "SWOT Analysis" },
  "swot.strengths": { es: "Fortalezas", en: "Strengths" },
  "swot.weaknesses": { es: "Debilidades", en: "Weaknesses" },
  "swot.opportunities": { es: "Oportunidades", en: "Opportunities" },
  "swot.threats": { es: "Amenazas", en: "Threats" },

  // Operations
  "ops.description": { es: "Descripción operativa", en: "Operations description" },
  "ops.services": { es: "Catálogo de servicios", en: "Services catalog" },
  "ops.add_service": { es: "Añadir servicio", en: "Add service" },
  "ops.service_name": { es: "Servicio", en: "Service" },
  "ops.service_desc": { es: "Descripción", en: "Description" },
  "ops.price": { es: "Precio (€)", en: "Price (€)" },
  "ops.margin": { es: "Margen (%)", en: "Margin (%)" },
  "ops.duration": { es: "Duración", en: "Duration" },
  "ops.processes": { es: "Procesos clave", en: "Key processes" },
  "ops.suppliers": { es: "Proveedores y partners", en: "Suppliers & partners" },

  // Risks
  "risk.title": { es: "Riesgos identificados", en: "Identified risks" },
  "risk.add": { es: "Añadir riesgo", en: "Add risk" },
  "risk.name": { es: "Riesgo", en: "Risk" },
  "risk.description": { es: "Descripción", en: "Description" },
  "risk.probability": { es: "Probabilidad", en: "Probability" },
  "risk.impact": { es: "Impacto", en: "Impact" },
  "risk.mitigation": { es: "Plan de mitigación", en: "Mitigation plan" },
  "risk.low": { es: "Baja", en: "Low" },
  "risk.medium": { es: "Media", en: "Medium" },
  "risk.high": { es: "Alta", en: "High" },

  // HR
  "hr.needs": { es: "Descripción de necesidades", en: "Needs description" },
  "hr.roles": { es: "Perfiles y responsabilidades", en: "Roles & responsibilities" },
  "hr.add_role": { es: "Añadir rol", en: "Add role" },
  "hr.title": { es: "Puesto", en: "Title" },
  "hr.responsibilities": { es: "Responsabilidades", en: "Responsibilities" },
  "hr.salary": { es: "Rango salarial (€)", en: "Salary range (€)" },
  "hr.headcount": { es: "Nº personas", en: "Headcount" },

  // Calendar
  "calendar.annual": { es: "Hitos anuales", en: "Annual milestones" },
  "calendar.five_year": { es: "Plan a 5 años", en: "5-Year plan" },
  "calendar.add_milestone": { es: "Añadir hito", en: "Add milestone" },
  "calendar.quarter": { es: "Trimestre", en: "Quarter" },
  "calendar.add_year": { es: "Añadir año", en: "Add year" },
  "calendar.year": { es: "Año", en: "Year" },
  "calendar.goals": { es: "Objetivos", en: "Goals" },

  // Marketing
  "marketing.b2b": { es: "Acciones B2B", en: "B2B Actions" },
  "marketing.b2c": { es: "Acciones B2C", en: "B2C Actions" },
  "marketing.digital": { es: "Campañas digitales", en: "Digital campaigns" },
  "marketing.add_action": { es: "Añadir acción", en: "Add action" },
  "marketing.add_campaign": { es: "Añadir campaña", en: "Add campaign" },
  "marketing.channel": { es: "Canal", en: "Channel" },
  "marketing.budget": { es: "Presupuesto (€)", en: "Budget (€)" },
  "marketing.platform": { es: "Plataforma", en: "Platform" },
  "marketing.leads": { es: "Leads", en: "Leads" },
  "marketing.conversions": { es: "Conversiones", en: "Conversions" },
  "marketing.target_cpl": { es: "CPL objetivo (€)", en: "Target CPL (€)" },
  "marketing.target_cac": { es: "CAC objetivo (€)", en: "Target CAC (€)" },
  "marketing.cpl": { es: "CPL", en: "CPL" },
  "marketing.cac": { es: "CAC", en: "CAC" },

  // Budget
  "budget.startup": { es: "Gastos de arranque", en: "Startup costs" },
  "budget.fixed": { es: "Gastos fijos mensuales", en: "Fixed monthly expenses" },
  "budget.variable": { es: "Gastos variables", en: "Variable expenses" },
  "budget.revenue": { es: "Fuentes de ingresos", en: "Revenue streams" },
  "budget.add_item": { es: "Añadir partida", en: "Add item" },
  "budget.add_revenue": { es: "Añadir ingreso", en: "Add revenue" },
  "budget.item": { es: "Concepto", en: "Item" },
  "budget.amount": { es: "Importe (€)", en: "Amount (€)" },
  "budget.monthly": { es: "Mensual (€)", en: "Monthly (€)" },
  "budget.growth": { es: "Crecimiento mensual (%)", en: "Monthly growth (%)" },
  "budget.projection": { es: "Proyección 12 meses", en: "12-month projection" },
  "budget.cash_flow": { es: "Cash flow", en: "Cash flow" },
  "budget.expenses": { es: "Gastos", en: "Expenses" },

  // Budget - financial (iteration 3)
  "fin.assumptions": { es: "Supuestos financieros", en: "Financial assumptions" },
  "fin.tax_rate": { es: "Tipo impositivo (%)", en: "Tax rate (%)" },
  "fin.initial_capital": { es: "Capital inicial (€)", en: "Initial capital (€)" },
  "fin.unit_revenue": { es: "Ticket medio por cliente (€)", en: "Avg revenue per customer (€)" },
  "fin.unit_variable": { es: "Coste variable por cliente (€)", en: "Variable cost per customer (€)" },
  "fin.yearly_rev_growth": { es: "Crecimiento ingresos anual (%)", en: "Yearly revenue growth (%)" },
  "fin.yearly_exp_growth": { es: "Crecimiento gastos anual (%)", en: "Yearly expense growth (%)" },
  "fin.breakeven": { es: "Punto de equilibrio", en: "Break-even analysis" },
  "fin.breakeven_subtitle": {
    es: "Cuántos clientes necesitas para cubrir los gastos fijos cada mes.",
    en: "How many customers you need to cover fixed costs each month.",
  },
  "fin.contribution_margin": { es: "Margen de contribución", en: "Contribution margin" },
  "fin.customers_per_month": { es: "Clientes/mes para equilibrio", en: "Customers/month at break-even" },
  "fin.revenue_per_month": { es: "Ingresos/mes para equilibrio", en: "Revenue/month at break-even" },
  "fin.month_breakeven": { es: "Mes en que llegas al equilibrio", en: "Month you reach break-even" },
  "fin.pl": { es: "Cuenta de resultados (P&L)", en: "Income statement (P&L)" },
  "fin.pl_subtitle": {
    es: "Vista anual: ingresos → margen bruto → resultado operativo → resultado neto.",
    en: "Annual view: revenue → gross margin → operating income → net income.",
  },
  "fin.revenue": { es: "Ingresos", en: "Revenue" },
  "fin.cogs": { es: "Coste de ventas", en: "Cost of goods sold" },
  "fin.gross_profit": { es: "Margen bruto", en: "Gross profit" },
  "fin.gross_margin": { es: "Margen bruto %", en: "Gross margin %" },
  "fin.opex": { es: "Gastos operativos", en: "Operating expenses" },
  "fin.operating_income": { es: "Resultado operativo (EBITDA)", en: "Operating income (EBITDA)" },
  "fin.tax": { es: "Impuestos", en: "Taxes" },
  "fin.net_income": { es: "Resultado neto", en: "Net income" },
  "fin.net_margin": { es: "Margen neto %", en: "Net margin %" },
  "fin.balance": { es: "Balance pro forma (fin Año 1)", en: "Pro forma balance sheet (EoY 1)" },
  "fin.assets": { es: "Activo", en: "Assets" },
  "fin.cash": { es: "Caja y equivalentes", en: "Cash & equivalents" },
  "fin.fixed_assets": { es: "Activos fijos (gastos arranque)", en: "Fixed assets (startup costs)" },
  "fin.total_assets": { es: "Total activo", en: "Total assets" },
  "fin.liabilities": { es: "Pasivo", en: "Liabilities" },
  "fin.equity": { es: "Patrimonio neto", en: "Equity" },
  "fin.paid_in": { es: "Capital aportado", en: "Paid-in capital" },
  "fin.retained": { es: "Beneficios retenidos", en: "Retained earnings" },
  "fin.total_liab_eq": { es: "Total pasivo + patrimonio", en: "Total liabilities + equity" },
  "fin.five_year": { es: "Proyección a 5 años", en: "5-year projection" },
  "fin.five_year_subtitle": {
    es: "Evolución de ingresos, gastos y resultado neto aplicando los % de crecimiento anual.",
    en: "Evolution of revenue, expenses and net income with yearly growth assumptions.",
  },
  "fin.year": { es: "Año", en: "Year" },
  "fin.cumulative_net": { es: "Beneficio acumulado", en: "Cumulative net" },
  "fin.scenarios": { es: "Comparador de escenarios", en: "Scenario comparison" },
  "fin.scenarios_subtitle": {
    es: "Best / Base / Worst case del Año 1 ajustando ingresos y gastos.",
    en: "Best / Base / Worst case for Year 1 by adjusting revenue and expenses.",
  },
  "fin.best": { es: "Optimista", en: "Best" },
  "fin.base": { es: "Base", en: "Base" },
  "fin.worst": { es: "Pesimista", en: "Worst" },
  "fin.best_rev_mult": { es: "Multiplicador ingresos (Best)", en: "Revenue multiplier (Best)" },
  "fin.worst_rev_mult": { es: "Multiplicador ingresos (Worst)", en: "Revenue multiplier (Worst)" },
  "fin.best_exp_mult": { es: "Multiplicador gastos (Best)", en: "Expense multiplier (Best)" },
  "fin.worst_exp_mult": { es: "Multiplicador gastos (Worst)", en: "Expense multiplier (Worst)" },

  // Common
  "common.save": { es: "Guardar", en: "Save" },
  "common.saved": { es: "Guardado", en: "Saved" },
  "common.delete": { es: "Eliminar", en: "Delete" },
  "common.add": { es: "Añadir", en: "Add" },
  "common.export_pdf": { es: "Exportar módulo", en: "Export module" },
  "common.export_full": { es: "Plan completo PDF", en: "Full plan PDF" },
  "common.back": { es: "Volver", en: "Back" },
  "common.ai_assist": { es: "Asistente IA", en: "AI Assistant" },
  "common.ask_ai": { es: "Preguntar a la IA", en: "Ask AI" },
  "common.ai_placeholder": {
    es: "Describe lo que necesitas. La IA te ayudará a redactarlo...",
    en: "Describe what you need. AI will help you draft it...",
  },
  "common.apply": { es: "Aplicar", en: "Apply" },
  "common.copy": { es: "Copiar", en: "Copy" },
  "common.generating": { es: "Generando...", en: "Generating..." },
  "common.loading": { es: "Cargando...", en: "Loading..." },

  // Brand
  "brand.name": { es: "Atelier Business", en: "Atelier Business" },
  "brand.tagline": { es: "Diseña tu negocio.", en: "Design your business." },

  // Catalog
  "catalog.title": { es: "Catálogo de inspiración", en: "Inspiration catalog" },
  "catalog.subtitle": {
    es: "12 planes de negocio completos, listos para inspirar o clonar como plantilla.",
    en: "12 complete business plans, ready to inspire or clone as a template.",
  },
  "catalog.eyebrow": { es: "Plantillas", en: "Templates" },
  "catalog.open_button": { es: "Ver plan", en: "View plan" },
  "catalog.demo_badge": { es: "Demo gratuita", en: "Free demo" },
  "catalog.locked_badge": { es: "Inicia sesión para previsualizar", en: "Sign in to preview" },
  "catalog.preview_badge": { es: "Vista previa parcial", en: "Partial preview" },
  "catalog.full_badge": { es: "Acceso completo", en: "Full access" },
  "catalog.investment_label": { es: "Inversión típica", en: "Typical investment" },
  "catalog.difficulty_label": { es: "Dificultad", en: "Difficulty" },
  "catalog.difficulty_baja": { es: "Baja", en: "Easy" },
  "catalog.difficulty_media": { es: "Media", en: "Medium" },
  "catalog.difficulty_alta": { es: "Alta", en: "Hard" },
  "catalog.coming_soon": { es: "Próximamente", en: "Coming soon" },
  "catalog.go_to_catalog": { es: "Catálogo de inspiración", en: "Inspiration catalog" },
  "catalog.dashboard_cta": {
    es: "Explora 12 planes de negocio reales · listos para clonar como plantilla.",
    en: "Explore 12 real business plans · ready to clone as templates.",
  },
  "catalog.back_to_catalog": { es: "Volver al catálogo", en: "Back to catalog" },
  "catalog.clone_button": { es: "Usar como plantilla", en: "Use as template" },
  "catalog.clone_button_locked": { es: "Suscribirse para clonar", en: "Subscribe to clone" },
  "catalog.viewing_demo": {
    es: "Estás viendo el plan demo gratuito. Crea tu cuenta para acceder al resto del catálogo.",
    en: "You're viewing the free demo plan. Create your account to access the rest of the catalog.",
  },
  "catalog.preview_alert": {
    es: "Vista previa parcial. Suscríbete al plan Basic para ver todos los módulos.",
    en: "Partial preview. Subscribe to Basic to see all modules.",
  },
  "catalog.locked_alert": {
    es: "Plan bloqueado. Inicia sesión para previsualizar 3 módulos · suscríbete a Basic para ver el plan completo.",
    en: "Plan locked. Sign in to preview 3 modules · subscribe to Basic for full access.",
  },
  "catalog.module_locked": { es: "Módulo bloqueado", en: "Locked module" },
  "catalog.module_locked_desc": {
    es: "Suscríbete al plan Basic para desbloquear este módulo.",
    en: "Subscribe to Basic to unlock this module.",
  },
  "catalog.cloned_success": { es: "Proyecto creado a partir de la plantilla.", en: "Project created from template." },
  "catalog.seed_pending": {
    es: "El contenido de este plan se está preparando. Vuelve en breve.",
    en: "This plan's content is being prepared. Check back soon.",
  },

  // Pricing
  "pricing.title": { es: "Planes y precios", en: "Plans & pricing" },
  "pricing.subtitle": {
    es: "Empieza gratis, sube de plan cuando quieras desbloquear todo el catálogo.",
    en: "Start free, upgrade whenever you want to unlock the full catalog.",
  },
  "pricing.per_month": { es: "/mes", en: "/mo" },
  "pricing.current": { es: "Tu plan actual", en: "Your current plan" },
  "pricing.upgrade": { es: "Pasar a este plan", en: "Upgrade to this plan" },
  "pricing.downgrade": { es: "Bajar a este plan", en: "Downgrade to this plan" },
  "pricing.choose": { es: "Elegir", en: "Choose" },
  "pricing.stripe_pending": {
    es: "Stripe se activará en producción. Por ahora, cambia de tier manualmente para probar la app.",
    en: "Stripe will be enabled in production. For now, toggle tiers manually to test the app.",
  },
  "pricing.free.title": { es: "Gratis", en: "Free" },
  "pricing.free.price": { es: "€0", en: "€0" },
  "pricing.free.tagline": { es: "Para descubrir el producto", en: "To discover the product" },
  "pricing.basic.title": { es: "Basic", en: "Basic" },
  "pricing.basic.price": { es: "€9,90", en: "€9.90" },
  "pricing.basic.tagline": { es: "Acceso completo al catálogo", en: "Full catalog access" },
  "pricing.standard.title": { es: "Standard", en: "Standard" },
  "pricing.standard.price": { es: "€19,90", en: "€19.90" },
  "pricing.standard.tagline": { es: "Catálogo + clonar plantillas", en: "Catalog + clone templates" },
  "pricing.free.f1": { es: "Tu propio plan ilimitado", en: "Your own unlimited plan" },
  "pricing.free.f2": { es: "Asistentes IA incluidos", en: "AI assistants included" },
  "pricing.free.f3": { es: "1 demo del catálogo (completa)", en: "1 catalog demo (full)" },
  "pricing.free.f4": { es: "Resto del catálogo: 3 pestañas de vista previa", en: "Rest of catalog: 3 preview tabs" },
  "pricing.basic.f1": { es: "Todo lo de Gratis", en: "Everything in Free" },
  "pricing.basic.f2": { es: "Acceso completo al catálogo (12+ planes)", en: "Full catalog access (12+ plans)" },
  "pricing.basic.f3": { es: "Exportar PDFs de cualquier plantilla", en: "Export PDFs of any template" },
  "pricing.basic.f4": { es: "Comparador de planes", en: "Plan comparator" },
  "pricing.standard.f1": { es: "Todo lo de Basic", en: "Everything in Basic" },
  "pricing.standard.f2": { es: "Clonar cualquier plan como plantilla propia", en: "Clone any plan as your own template" },
  "pricing.standard.f3": { es: "Proyectos ilimitados clonados", en: "Unlimited cloned projects" },
  "pricing.standard.f4": { es: "Prioridad en nuevas plantillas", en: "Priority on new templates" },

  // Subscription badges (header)
  "subscription.tier_free": { es: "Plan Gratis", en: "Free plan" },
  "subscription.tier_basic": { es: "Plan Starter", en: "Starter plan" },
  "subscription.tier_standard": { es: "Plan Pro", en: "Pro plan" },
  "subscription.tier_starter": { es: "Plan Starter", en: "Starter plan" },
  "subscription.tier_pro": { es: "Plan Pro", en: "Pro plan" },

  // 3-tier paywall (iter27)
  "paywall.upgrade_starter": { es: "Activar Starter — 49,90 €/mes", en: "Activate Starter — $49.90/mo" },
  "paywall.upgrade_pro": { es: "Activar Pro — 99,90 €/mes", en: "Activate Pro — $99.90/mo" },
  "paywall.see_plans": { es: "Ver planes", en: "See plans" },
  "paywall.ai_locked_title": { es: "Herramientas IA bloqueadas", en: "AI tools locked" },
  "paywall.ai_locked_desc": {
    es: "Activa Starter o Pro para usar el asistente IA, la entrevista guiada y el pitch deck.",
    en: "Activate Starter or Pro to use the AI assistant, guided interview and pitch deck.",
  },
  "paywall.cancelled_banner": {
    es: "Tu suscripción está cancelada. Puedes leer y editar manualmente tus planes guardados, pero las herramientas IA y la creación de nuevos planes están desactivadas.",
    en: "Your subscription is cancelled. You can read and manually edit saved plans, but AI tools and new plan creation are disabled.",
  },
  "paywall.starter_pick_title": { es: "Elige esta plantilla para tu cupo", en: "Add this template to your slots" },
  "paywall.starter_pick_desc": {
    es: "Starter incluye 6 plantillas a tu elección. Una vez añadida la podrás abrir y clonar tantas veces como quieras.",
    en: "Starter includes 6 templates of your choice. Once added you can open and clone it as many times as you want.",
  },
  "paywall.starter_pick_cta": { es: "Añadir a mis plantillas", en: "Add to my templates" },
  "paywall.starter_slots_full": {
    es: "Has usado tus 6 plantillas Starter. Sube a Pro para acceso ilimitado.",
    en: "You've used all 6 Starter templates. Upgrade to Pro for unlimited access.",
  },
  "paywall.monthly_quota": { es: "{used}/{limit} planes este mes", en: "{used}/{limit} plans this month" },
  "paywall.lifetime_quota": { es: "{used}/{limit} plan creado", en: "{used}/{limit} plan created" },
};

export const t = (key, lang = "es") => {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry.es || key;
};

// Buyer persona templates
export const PERSONA_TEMPLATES = {
  retiree_us: {
    name: "Robert & Susan — US Retirees",
    age: "62-68",
    role: "Pareja jubilada / Retired couple",
    goals: "Vivir mejor con su pensión, conocer nuevas culturas, mejorar calidad de vida.",
    pains: "Burocracia, idioma, fiscalidad doble (US/EU), miedo al cambio.",
    channels: "Facebook groups, YouTube, AARP, podcasts de retirement.",
  },
  remote_worker: {
    name: "Alex — Remote Tech Worker",
    age: "32-42",
    role: "Profesional remoto / Digital nomad",
    goals: "Flexibilidad, coste de vida menor, comunidad internacional.",
    pains: "Visados, fiscalidad, conexión a internet, soledad.",
    channels: "Twitter, LinkedIn, Nomad List, Reddit r/digitalnomad.",
  },
  young_family: {
    name: "Maria & Juan — Young Family",
    age: "30-40",
    role: "Familia joven con hijos",
    goals: "Educación bilingüe, seguridad, balance vida-trabajo.",
    pains: "Coste de educación, integración, salud infantil.",
    channels: "Instagram, blogs de familias expat, grupos de WhatsApp locales.",
  },
};
